import { useContext } from 'react';

import ParametersContext from 'search-filter/contexts/ParametersContext';

const useParametersContext = () => useContext(ParametersContext);

export default useParametersContext;
